export default "__VITE_ASSET__XowJ4ite__"